import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'header-nuovo-ordine',
    templateUrl: './header-nuovo-ordine.component.html',
    styleUrls: ['./header-nuovo-ordine.component.scss']
})
export class HeaderNuovoOrdineComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
